import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	linkAs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkAsRelatesTo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dropdownLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	linkAs: {
		id: 'ai-related-issues.link-as',
		defaultMessage: 'Link as',
		description: 'Text to link as',
	},
	linkAsRelatesTo: {
		id: 'ai-related-issues.link-as-relates-to',
		defaultMessage: 'Link as related',
		description: 'Text to link as related',
	},
	dropdownLabel: {
		id: 'ai-related-issues.link-split-button.dropdown-label',
		defaultMessage: 'More work items relationship types',
		description: 'Text for dropdown label',
	},
});
export default messages;
